import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Material UI
import DialogContentText from '@material-ui/core/DialogContentText';
// HOCs
import withThemeColors from 'components/core/hocs/WithThemeColors';
// Custom
import { themeColorsShape } from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';

const iconSettings = (themeColors) => ({
  info: {
    id: 'info',
    color: themeColors.info,
  },
  warning: {
    id: 'warning',
    color: themeColors.warning,
  },
  danger: {
    id: 'error',
    color: themeColors.error,
  },
});

const InfoMessage = ({ message: { id, values, level }, themeColors }) => (
  <div>
    <div className="text-center mb-3">
      <AppIcon {...iconSettings(themeColors)[level]} style={{ width: '40px', height: '40px' }} />
    </div>
    <DialogContentText className="text-center">
      <LocalizedMessage id={`${id}`} values={values} />
    </DialogContentText>
  </div>
);

InfoMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    values: PropTypes.object,
    level: PropTypes.string.isRequired,
  }).isRequired,
  themeColors: themeColorsShape.isRequired,
};

module.exports = withThemeColors(InfoMessage);



// WEBPACK FOOTER //
// ./components/dialogs/InfoMessage.js